
import JsonApiObject from '@/_models/JsonApi'
import ContractorsDialog from '@/views/Authorization/dialogs/userEdit/contractorsDialog.vue'

export default {
    name: 'ProjectContractorSelect',
    props: {
        contractor: Object,
    },
    computed: {
        contractorInfo() {
            let name = '',
                path = ''

            const namePath = this.contractor?.namePath

            if (Array.isArray(namePath) && namePath.length > 0) {
                name = namePath[namePath.length - 1]
                if (namePath.length > 1) {
                    path = namePath.join(' → ')
                }
            }

            return { name, path }
        },
    },
    methods: {
        async openContractorDialog() {
            const result = await JsonApiObject.openDialog(ContractorsDialog, {
                contractor: this.contractor,
            })
            if (Array.isArray(result)) {
                this.$emit('update', result)
            }
        },
    },
}
